import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { AdminUsersList } from "../types";
import axiosClient from "../utils/axiosClient";

export const useAdminAllUsers = (
  pageTable: number,
  resultsPerPage: number = 20,
  searchString:string = ""
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, AdminUsersList>(
    ["adminUserList", pageTable, searchString],
    () =>
      axiosClient
        .get<AdminUsersList>(`/admin/users/${newSkip}/${resultsPerPage}${searchString ? '?name='+searchString : ""}`)
        .then(({ data }) => data),
    {
      staleTime: Infinity,
      keepPreviousData: true,
    }
  );
};
